"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const storage_1 = __importDefault(require("../storage"));
const ClientSideRenderOnly_1 = __importDefault(require("./ClientSideRenderOnly"));
const PrivacyCaret_1 = __importDefault(require("./PrivacyCaret"));
const PrivacyGear_1 = __importDefault(require("./PrivacyGear"));
const PrivacyGroup_1 = __importDefault(require("./PrivacyGroup"));
const styles_1 = require("./styles");
const usePrivacyText_1 = __importDefault(require("./usePrivacyText"));
const PrivacyModal = ({ categories, onOptInChange }) => {
    const interacted = react_1.default.useRef(storage_1.default.getItem('MDRNA_CONSENT') !== null);
    const [detailsExpanded, setDetailsExpanded] = react_1.default.useState(false);
    const [categoriesSelected, setCategoriesSelected] = react_1.default.useState(() => {
        var _a;
        const categoriesStored = (_a = storage_1.default.getItem('MDRNA_CONSENT')) === null || _a === void 0 ? void 0 : _a.split(',');
        // If the categories have never been stored, mark them all as on by
        // default. This won't enable them, just have them appear enabled.
        if (!(categoriesStored === null || categoriesStored === void 0 ? void 0 : categoriesStored.length)) {
            return categories;
        }
        else {
            return categories.filter((category) => categoriesStored.includes(category));
        }
    });
    const [visible, setVisible] = react_1.default.useState(() => storage_1.default.getItem('MDRNA_CONSENT') === null);
    const text = (0, usePrivacyText_1.default)();
    const handleDetailsToggleClick = react_1.default.useCallback(() => {
        setDetailsExpanded(!detailsExpanded);
    }, [detailsExpanded, setDetailsExpanded]);
    const handleCategoriesSelect = react_1.default.useCallback((categoriesNext) => {
        interacted.current = true;
        setCategoriesSelected(categoriesNext);
    }, []);
    const handleOptOutAllClick = react_1.default.useCallback(() => {
        setVisible(false);
        setCategoriesSelected(['necessary']);
        storage_1.default.setItem('MDRNA_CONSENT', 'necessary');
        categories.forEach((category) => category !== 'necessary' && onOptInChange(category, false));
    }, [categories, onOptInChange]);
    const handleOptInAllClick = react_1.default.useCallback(() => {
        setVisible(false);
        storage_1.default.setItem('MDRNA_CONSENT', categoriesSelected.join(','));
        categories.forEach((category) => category !== 'necessary' && onOptInChange(category, categoriesSelected.includes(category)));
    }, [categories, categoriesSelected, onOptInChange]);
    const handlePrivacyGearChange = react_1.default.useCallback((visibleNext) => {
        setVisible(visibleNext);
        // If the checkboxes have been interacted with, assume the intention was to
        // save the current opt in state.
        if (interacted.current && visibleNext === false) {
            storage_1.default.setItem('MDRNA_CONSENT', categoriesSelected.join(','));
            categories.forEach((category) => category !== 'necessary' && onOptInChange(category, categoriesSelected.includes(category)));
        }
    }, [categories, categoriesSelected, onOptInChange]);
    react_1.default.useEffect(() => {
        const idAttribute = 'PrivacyModalStyles';
        if (!document.getElementById(idAttribute)) {
            const styleSheet = document.createElement('style');
            styleSheet.setAttribute('id', idAttribute);
            styleSheet.innerText = (0, styles_1.getStyles)();
            document.head.appendChild(styleSheet);
        }
        return () => {
            var _a;
            (_a = document.getElementById(idAttribute)) === null || _a === void 0 ? void 0 : _a.remove();
        };
    }, []);
    if (!visible) {
        return react_1.default.createElement(PrivacyGear_1.default, { onChange: handlePrivacyGearChange, visible: visible });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "privacy__overlay" }),
        react_1.default.createElement("div", { className: "privacy__content" },
            react_1.default.createElement("h2", { className: "privacy__text privacy__heading" }, text.heading),
            react_1.default.createElement("p", { className: "privacy__text" },
                text.headingDescription,
                "\u00A0",
                react_1.default.createElement("a", { className: "privacy__link", href: text.headingReadMoreURL, target: "_blank", rel: "noreferrer" }, text.headingReadMore)),
            detailsExpanded && (react_1.default.createElement("div", { className: "privacy__groups" },
                react_1.default.createElement(PrivacyGroup_1.default, { description: text.strictlyNecessaryDescription, category: "necessary", categoriesSelected: categoriesSelected, setCategoriesSelected: handleCategoriesSelect, title: text.strictlyNecessaryHeading }),
                categories.includes('performance') && (react_1.default.createElement(PrivacyGroup_1.default, { categoriesSelected: categoriesSelected, category: "performance", description: text.performanceDescription, setCategoriesSelected: handleCategoriesSelect, title: text.performanceHeading, tools: [
                        {
                            description: text.amplitudeDescription,
                            duration: text.amplitudeDuration,
                            provider: text.amplitudeProvider
                        }
                    ] })))),
            react_1.default.createElement("div", { className: "privacy__footer" },
                react_1.default.createElement("button", { className: "privacy__text privacy__expand", onClick: handleDetailsToggleClick, role: "button" },
                    detailsExpanded ? text.showLess : text.showDetails,
                    react_1.default.createElement(PrivacyCaret_1.default, { expanded: detailsExpanded })),
                react_1.default.createElement("div", { className: "privacy__footer__ctas" },
                    react_1.default.createElement("button", { "data-track": "privacy-consent-deny", className: "privacy__button privacy__button--secondary", onClick: handleOptOutAllClick, role: "button" }, text.deny),
                    react_1.default.createElement("button", { "data-track": "privacy-consent-accept", className: "privacy__button privacy__button--primary", onClick: handleOptInAllClick, role: "button" }, text.accept)))),
        react_1.default.createElement(PrivacyGear_1.default, { onChange: handlePrivacyGearChange, visible: visible })));
};
const PrivacyModalClientSideRenderOnly = (props) => {
    return (react_1.default.createElement(ClientSideRenderOnly_1.default, null,
        react_1.default.createElement(PrivacyModal, { ...props })));
};
exports.default = PrivacyModalClientSideRenderOnly;
